import React from 'react';
import { Construction } from 'lucide-react';

interface PlaceholderPageProps {
  title: string;
}

export const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title }) => {
  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-2xl font-semibold text-gray-900 mb-8">{title}</h1>
      <div className="bg-white rounded-lg shadow-sm p-8 text-center">
        <Construction className="w-16 h-16 text-blue-500 mx-auto mb-4" />
        <h2 className="text-xl font-medium text-gray-900 mb-2">
          Esta funcionalidad estará disponible próximamente
        </h2>
        <p className="text-gray-600">
          Estamos trabajando para brindarte la mejor experiencia posible.
        </p>
      </div>
    </div>
  );
};